import React from 'react';

//Estilos
import './NewDJMV.css';
import TableContainer from '../../components/table/TableContainer';

function NewDJMV({ functions, states }) {
    const { tableData, DJTVData } = states;

    const { handleSubmit, onSubmit } = functions;

    return (
        <div className="newDJMV-container">
            <form className="newDJMV-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de Modificación de Viñedo ${DJTVData?.cabecera?.serie}-P-${DJTVData?.cabecera?.numero}${DJTVData?.cabecera?.viniedo}`}
                </h4>
                <TableContainer tableData={tableData} />
                <div className="newDJMV-footer">
                    <button
                        type="submit"
                        className="btn btn-primary btn-submit-newDJMV"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewDJMV;
